import { initializeApp } from 'firebase/app';
import config from '../config.json';

const firebaseApp = initializeApp(config.firebase);

export default { firebaseApp };